export const INIT_CART = 'initCart';
export const UPDATE_CART = 'updateCart';
export const UPDATE_ORDER = 'updateOrder';
export const UPDATE_ORDER_ITEM = 'updateOrderItem';
export const UPDATE_ORDER_ITEM_CONFIGURATION = 'updateOrderItemConfiguration';
export const DELETE_CART = 'deleteCart';
export const UPDATE_EVENTS = 'updateEvents';
export const UPDATE_SLOTS = 'updateSlots';
export const UPDATE_PRODUCTS = 'updateProducts';
export const UPDATE_CLIENTS = 'updateClients';
export const UPDATE_VISITOR_SEGMENTS = 'updateVisitorSegments';
export const UPDATE_EXHIBITOR_DATA = 'updateExhibitorData';
export const SET_LANGUAGE = 'setLanguage';
export const INIT_BUYER_DATA = 'initBuyerData';
export const SET_BUYER_DATA = 'setBuyerData';
export const CLEAR_BUYER_DATA = 'clearBuyerData';
export const INIT_SESSION = 'initSession';
export const SET_SESSION = 'setSession';
export const CLEAR_SESSION = 'clearSession';
export const SET_REGISTRATION_CODES = 'setRegistrationCodes';
export const CLEAR_REGISTRATION_CODES = 'clearRegistrationCodes';
export const INIT_REGISTRATION_CODES = 'initRegistrationCodes';
export const SET_IS_GUEST_ORDER = 'setIsGuestOrder';
export const INIT_IS_GUEST_ORDER = 'initIsGuestOrder';
export const CLEAR_IS_GUEST_ORDER = 'clearIsGuestOrder';
export const SET_COUNTRIES = 'setCountries';
export const SET_STATES = 'setStates';
export const SET_TITLES = 'setTitles';
export const SET_ENABLE_TICKET_SHOP = 'setEnableTicketShop';
export const SET_LOGIN_RETURN_URL = 'setLoginReturnUrl';
export const CLEAR_LOGIN_RETURN_URL = 'clearLoginReturnUrl';
export const INIT_LOGIN_RETURN_URL = 'initLoginReturnUrl';
export const INIT_USER = 'initLmsUser';
export const SET_USER = 'setLmsUser';
export const CLEAR_USER = 'clearLmsUser';
export const UPDATE_PAYMENT_METHODS = 'updatePaymentMethods';
